import ABCyaLib from "@abcya/abcya_lib";
import AScene from "./ExtendedObjects/AScene.js";
import InputHelper from "./InputHelper.js";

export default class Utils
{
    static Initialize(game)
    {
        this.game = game;
    }

    static GetGame()
    {
        return this.game;
    }
	
	 /**
     * @param {function(Number)} updateMethod passes deltaTime as the parameter
     */
    static temporaryUpdate(updateMethod, duration, ease = null, onComplete = null)
    {
        this.scene.temporary_number = 0;
        let prevVal = 0;
        this.scene.addTween(this.scene, duration, {temporary_number: 1, onUpdate: ()=>{
            let normalizedChange = this.scene.temporary_number - prevVal;
            method(normalizedChange * duration);
            prevVal = this.scene.temporary_number;
        }}, ease, onComplete);
    }

    static TransitionScenes(oldScene, newScene_Name, duration, directionY = 1, directionX = 0, ease = "Sinusoidal", data = null)
    {
        oldScene.scene.launch(newScene_Name, data);
        let newChildren = oldScene.game.scene.keys[newScene_Name].children.list;
        let oldChildren = oldScene.children.list;

        oldScene.addDelay(0, ()=>{
            for(let i = 0; i < newChildren.length; i++)
            {
                let child = newChildren[i];
                let oldPos = {x: child.x, y: child.y};
                child.setPosition(child.x + (oldScene.size.width * directionX), child.y + (oldScene.size.height * directionY));
                oldScene.addTween(child, duration, {x: oldPos.x, y: oldPos.y}, ease);
            }
            for(let i = 0; i < oldChildren.length; i++)
            {
                oldScene.addTween(oldChildren[i], duration, {x: oldChildren[i].x - (oldScene.size.width - 2) * directionX, y: oldChildren[i].y - (oldScene.size.height - 2) * directionY}, ease);
            }
            oldScene.addDelay(duration, ()=>{
                oldScene.scene.stop();
            });
        });
    }

    static TopParent(object)
    {
        let curobject = object;
        while(1)
        {
            if(curobject.parentContainer == null) return curobject;
            curobject = curobject.parentContainer;
        }
    }

    static StagePos(object)
    {
        let curobject = object;
        let pos = {x: curobject.x, y: curobject.y};
        while(curobject.parentContainer != null)
        {
            curobject = curobject.parentContainer;
            pos.x += curobject.x;
            pos.y += curobject.y;
        }

        return pos;
    }

    static RemoveDuplicates(largeArr, toRemove)
    {
        let newArr = [];
        for(let i = 0; i < largeArr.length; i++)
        {
            if(toRemove.indexOf(largeArr[i]) == -1)
            {
                newArr.push(largeArr[i]);
            }
        }
        return newArr;
    }

    /**
     *  @param {AScene} scene 
     */
    static set CurrentScene(scene)
    {
        this.scene = scene;
    }

    /**
     * Adds the abilitiy to manipulate a given this.manipulatedObject. A and D change angle. Middle click sets position, W and S change scale. Up, Down, Left and Right change position.
     */
    static ManipulateObject(object, onManipulated = null, logData = false)
    {
        this.manipulatedObject = object;

        let logDataFunc = ()=>{
            //console.log((object.frame ? "frame: " + object.frame.name + ",\n" : "") + "x: " + object.x + ", y: " + object.y + ",\nangle: " + object.angle + ",\nscaleX: " + object.scaleX + ",\nscaleY: " + object.scaleY);
        };

        InputHelper.Listen(InputHelper.KeyCodes.D, ()=>{
            this.manipulatedObject.angle++;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.A, ()=>{
            this.manipulatedObject.angle--;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.W, ()=>{
            let incrementX = this.manipulatedObject.scaleX > 0 ? .05 : -.05;
            let incrementY = this.manipulatedObject.scaleY > 0 ? .05 : -.05;
            this.manipulatedObject.scaleX += incrementX;
            this.manipulatedObject.scaleY += incrementY;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.S, ()=>{
            let incrementX = this.manipulatedObject.scaleX > 0 ? -.05 : .05;
            let incrementY = this.manipulatedObject.scaleY > 0 ? -.05 : .05;
            this.manipulatedObject.scaleX += incrementX;
            this.manipulatedObject.scaleY += incrementY;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.UP, ()=>{
            this.manipulatedObject.y -= 1;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.DOWN, ()=>{
            this.manipulatedObject.y += 1;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.LEFT, ()=>{
            this.manipulatedObject.x -= 1;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.RIGHT, ()=>{
            this.manipulatedObject.x += 1;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.OPEN_BRACKET, ()=>{
            this.manipulatedObject.scaleX *= -1;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        InputHelper.Listen(InputHelper.KeyCodes.CLOSED_BRACKET, ()=>{
            this.manipulatedObject.scaleY *= -1;
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
        this.scene.input.on('pointerdown', (pointer)=>{
            if(!this.manipulatedObject || pointer.event.button != 1) return;
            this.manipulatedObject.setPosition(this.scene.input.x, this.scene.input.y);
            if(onManipulated) onManipulated(this.manipulatedObject);
            if(logData) logDataFunc();
        });
    }

    static Shuffle(array) 
    { 
        return array.map((a) => [Math.random(),a]).sort((a,b) => a[0]-b[0]).map((a) => a[1]);
    }

    static remove(arr, item) 
    { 
        let index = arr.indexOf(item);
        if(index != -1) arr.splice(index, 1); 
    }

    static copy(arr) 
    { 
        return arr.concat();
    }

    static contains(arr, item) 
    { 
        return (arr.indexOf(item) != -1); 
    }

    static GetRandomString(stringLength = 8)
    {
        let chars = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
        let randomstring = '';
        for (let i = 0; i < stringLength; i++) 
        {
            let rand = Phaser.Math.Between(0, chars.length - 1);
            randomstring += chars[rand];
        }

        return randomstring;
    }

    static SaveObject(key, object)
    {
        ABCyaLib.Storage.saveObject(key, object);
    }

    static GetObject(key)
    {
        return ABCyaLib.Storage.getObject(key);
    }

    static get TWEEN_CONST() {
        return {
            CREATED: 0,
            INIT: 1,
            DELAY: 2,
            OFFSET_DELAY: 3,
            PENDING_RENDER: 4,
            PLAYING_FORWARD: 5,
            PLAYING_BACKWARD: 6,
            HOLD_DELAY: 7,
            REPEAT_DELAY: 8,
            COMPLETE: 9,
            PENDING_ADD: 20,
            PAUSED: 21,
            LOOP_DELAY: 22,
            ACTIVE: 23,
            COMPLETE_DELAY: 24,
            PENDING_REMOVE: 25,
            REMOVED: 26
        }
    }
}
